import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import useSWR from "swr";
import { buildRecentStopSummaryUrl, getRecentStopIds } from "./recentStopRequest.js";
async function fetchRecentStopSummaries(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Failed to load recent stop summaries");
  }
  const results = await response.json();
  return Array.isArray(results) ? results : [];
}
export function useRecentStopSummaries(t0) {
  const $ = _c(13);
  const {
    recents,
    version
  } = t0;
  let t1;
  if ($[0] !== recents) {
    t1 = getRecentStopIds(recents);
    $[0] = recents;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const stopIds = t1;
  let t2;
  if ($[2] !== stopIds || $[3] !== version) {
    t2 = buildRecentStopSummaryUrl(stopIds, version);
    $[2] = stopIds;
    $[3] = version;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const key = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      refreshInterval: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 31536000000
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    error,
    isLoading
  } = useSWR(key, fetchRecentStopSummaries, t3);
  let t4;
  if ($[6] !== data || $[7] !== stopIds) {
    const stopsById = new Map((Array.isArray(data) ? data : []).map(_temp));
    t4 = stopIds.map(stopId => stopsById.get(stopId)).filter(Boolean);
    $[6] = data;
    $[7] = stopIds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const recentStops = t4;
  const t5 = key !== null && isLoading;
  let t6;
  if ($[9] !== error || $[10] !== recentStops || $[11] !== t5) {
    t6 = {
      data: recentStops,
      error,
      isLoading: t5
    };
    $[9] = error;
    $[10] = recentStops;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(stop) {
  return [stop.stop_id, stop];
}